const i18nConfig = {
  locales: ['de', 'en', 'pl'],
  defaultLocale: 'pl',
  prefixDefault: true
};

module.exports = i18nConfig;